//引入localforage
import localforage from "localforage"
localforage.config({
	name: "GeelyEmail",
	description: "用于存储邮件详情和邮件列表"
})
localforage
	.getItem("emailInfoArr")
	.then(val => {
		//emailInfoArr不存在的时候赋值空数组
		if (!val) localforage.setItem("emailInfoArr", [])
	})
	.catch(err => {
		console.log(err)
	})
localforage
	.getItem("emailListArr")
	.then(val => {
		//emailListArr不存在的时候赋值空数组
		if (!val) localforage.setItem("emailListArr", [])
	})
	.catch(err => {
		console.log(err)
	})
localforage
	.getItem("folderArr")
	.then(val => {
		//folderArr不存在的时候赋值空数组
		if (!val) localforage.setItem("folderArr", [])
	})
	.catch(err => {
		console.log(err)
	})

export default {
	getUrlParamsBystr(str) {
		let urlParam = {}
		if (str.indexOf('?') > -1) {
			str.split('?')[1]
				.split('&')
				.forEach((v) => {
					let param = v.split('=')
					urlParam[param[0]] = param[1]
				})
		}
		return urlParam
	},
	// 清除本地用户信息
	clearLocalStorageUserInfo() {
		localStorage.removeItem("Token")
		localStorage.removeItem("UserId")
		localStorage.removeItem("Account")
		localStorage.removeItem("UserName")
		localStorage.removeItem("LogTime")
		localStorage.removeItem("Layout")
	},
	// 返回对象类型
	// 返回值：Object/Function/Array/String/RegExp
	getType(obj) {
		return Object.prototype.toString
			.call(obj)
			.slice(1, -1)
			.split(" ")[1]
	},
	goodTime(str) {
		let now = new Date().getTime()
		let oldTime = new Date(str).getTime()
		let difference = now - oldTime
		let result = ""
		let minute = 1000 * 60
		let hour = minute * 60
		let day = hour * 24
		let month = day * 30
		let year = month * 12
		let _year = difference / year
		let _month = difference / month
		let _week = difference / (7 * day)
		let _day = difference / day
		let _hour = difference / hour
		let _min = difference / minute

		if (_year >= 1) {
			result = "发表于 " + ~~_year + " 年前"
		} else if (_month >= 1) {
			result = "发表于 " + ~~_month + " 个月前"
		} else if (_week >= 1) {
			result = "发表于 " + ~~_week + " 周前"
		} else if (_day >= 1) {
			result = "发表于 " + ~~_day + " 天前"
		} else if (_hour >= 1) {
			result = "发表于 " + ~~_hour + " 个小时前"
		} else if (_min >= 1) {
			result = "发表于 " + ~~_min + " 分钟前"
		} else {
			result = "刚刚"
		}
		return result
	},
	// 获取接口前缀
	getApiPrefix() {
		return {
			// 用户中心接口前缀
			// exchangeapi: "exchangeapi"
			exchangeapi: "webmailapi"
		}
	},
	//浏览器本地保存邮件详情（使用localforage）
	localSaveEmailInfo(emailInfo) {
		localforage
			.getItem("emailInfoArr")
			.then(val => {
				let arr = val
				//本地存储的邮件详情超过50条时删除最后一条，然后再添加一条最新的邮件详情
				if (arr.length >= 50) arr.pop()
				arr.unshift(emailInfo)
				localforage.setItem("emailInfoArr", arr)
			})
			.catch(err => {
				console.log(err)
			})
	},
	//浏览器本地保存邮件列表第一页（使用localforage）
	localSaveEmailList(emailList) {
		localforage
			.getItem("emailListArr")
			.then(val => {
				let arr = val
				//本地存储的邮件列表超过50条时删除第一条，然后再添加一条最新的邮件详情
				if (arr.length >= 50) arr.pop()
				arr.unshift(emailList)
				localforage.setItem("emailListArr", arr)
			})
			.catch(err => {
				console.log(err)
			})
	},
	//浏览器本地保存文件夹目录（使用localforage）
	localSaveFolder(folder) {
		localforage
			.getItem("folderArr")
			.then(val => {
				let arr = val
				//本地存储的邮件列表超过50条时删除第一条，然后再添加一条最新的邮件详情
				if (arr.length >= 50) arr.pop()
				arr.unshift(folder)
				localforage.setItem("folderArr", arr)
			})
			.catch(err => {
				console.log(err)
			})
	},
	// 自定义的countly跟踪事件
	countlyEvents: {
		// 通过账号密码登录
		loginClicked(data) {
			// Countly.add_event({
			// 	// key: "mail_login_clicked",
			// 	key: "通过账号密码登录",
			// 	count: 1,
			// 	segmentation: data || null
			// })
		},
		// 写邮件
		mailWrite(data) {
			// Countly.add_event({
			// 	// key: "mail_write",
			// 	key: "写邮件",
			// 	count: 1,
			// 	segmentation: data || null
			// })
		},
		// 定时发送邮件
		sendTimed(data) {
			// Countly.add_event({
			// 	// key: "mail_send_timed",
			// 	key: "定时发送邮件",
			// 	count: 1,
			// 	segmentation: data || null
			// })
		},
		// 发邮件
		mailSend(data) {
			// Countly.add_event({
			// 	// key: "mail_send",
			// 	key: "发送邮件",
			// 	count: 1,
			// 	segmentation: data || null
			// })
		},
		// 回复
		mailReply(data) {
			// Countly.add_event({
			// 	// key: "mail_detail_reply",
			// 	key: "回复邮件",
			// 	count: 1,
			// 	segmentation: data || null
			// })
		},
		// 回复所有人
		mailReplyAll(data) {
			// Countly.add_event({
			// 	// key: "mail_detail_replyall",
			// 	key: "回复所有人",
			// 	count: 1,
			// 	segmentation: data || null
			// })
		},
		// 转发邮件
		mailForward(data) {
			// Countly.add_event({
			// 	// key: "mail_detail_forward",
			// 	key: "转发邮件",
			// 	count: 1,
			// 	segmentation: data || null
			// })
		},
		// 查看邮件预览
		mailPreview(data) {
			// Countly.add_event({
			// 	// key: "mail_to_content",
			// 	key: "预览邮件",
			// 	count: 1,
			// 	segmentation: data || null
			// })
		},
		// 查看邮件详情
		mailDetail(data) {
			// Countly.add_event({
			// 	// key: "mail_to_detail",
			// 	key: "双击查看邮件详细",
			// 	count: 1,
			// 	segmentation: data || null
			// })
		},
		// 附件下载
		attachDownload(data) {
			// Countly.add_event({
			// 	// key: "mail_download",
			// 	key: "附件下载",
			// 	count: 1,
			// 	segmentation: data || null
			// })
		},
		// 按时间排序
		sortDate(data) {
			// Countly.add_event({
			// 	// key: "mail_sort_date",
			// 	key: "按时间排序",
			// 	count: 1,
			// 	segmentation: data || null
			// })
		},
		// 按发件人排序
		sortSender(data) {
			// Countly.add_event({
			// 	// key: "mail_sort_Sender",
			// 	key: "按发件人排序",
			// 	count: 1,
			// 	segmentation: data || null
			// })
		},
		// 邮件搜索
		mailSearch(data) {
			// Countly.add_event({
			// 	// key: "mail_search",
			// 	key: "邮件搜索",
			// 	count: 1,
			// 	segmentation: data || null
			// })
		},
		// 邮件高级搜索
		mailAdSearch(data) {
			// Countly.add_event({
			// 	// key: "mail_advancedsearch",
			// 	key: "邮件高级搜索",
			// 	count: 1,
			// 	segmentation: data || null
			// })
		},
		// 邮件存草稿
		mailSave(data) {
			// Countly.add_event({
			// 	// key: "mail_save",
			// 	key: "保存草稿",
			// 	count: 1,
			// 	segmentation: data || null
			// })
		},
		// 进入地址簿
		mailAddress(data) {
			// Countly.add_event({
			// 	// key: "mail_address",
			// 	key: "进入地址簿",
			// 	count: 1,
			// 	segmentation: data || null
			// })
		},
		// 添加收件人
		mailWriteRecipient(data) {
			// Countly.add_event({
			// 	// key: "mail_write_recipient",
			// 	key: "手动输入联系人",
			// 	count: 1,
			// 	segmentation: data || null
			// })
		},
		// 粘贴收件人
		mailCopyRecipient(data) {
			// Countly.add_event({
			// 	// key: "mail_copy_recipient",
			// 	key: "粘贴的联系人",
			// 	count: 1,
			// 	segmentation: data || null
			// })
		},
		// 关闭写信界面
		mailWriteClose(data) {
			// Countly.add_event({
			// 	// key: "mail_write_close",
			// 	key: "关闭写邮件界面",
			// 	count: 1,
			// 	segmentation: data || null
			// })
		},
		// 添加常用联系人
		addContacts(data) {
			// Countly.add_event({
			// 	// key: "mail_add_contacts",
			// 	key: "添加常用联系人",
			// 	count: 1,
			// 	segmentation: data || null
			// })
		},
		// 删除常用联系人
		deleteContacts(data) {
			// Countly.add_event({
			// 	// key: "mail_delete_contacts",
			// 	key: "删除常用联系人",
			// 	count: 1,
			// 	segmentation: data || null
			// })
		},
		// 地址簿中添加群组
		addGroup(data) {
			// Countly.add_event({
			// 	// key: "mail_add_group",
			// 	key: "添加联系人群组",
			// 	count: 1,
			// 	segmentation: data || null
			// })
		},
		// 地址簿中删除群组
		deleteGroup(data) {
			// Countly.add_event({
			// 	// key: "mail_delete_group",
			// 	key: "删除联系人群组",
			// 	count: 1,
			// 	segmentation: data || null
			// })
		},
		// 地址簿中编辑群组
		editGroup(data) {
			// Countly.add_event({
			// 	// key: "mail_edit_group",
			// 	key: "编辑联系人群组",
			// 	count: 1,
			// 	segmentation: data || null
			// })
		},
		// 标记为重要
		markImportant(data) {
			// Countly.add_event({
			// 	// key: "mail_important",
			// 	key: "选择邮件重要性",
			// 	count: 1,
			// 	segmentation: data || null
			// })
		},
		// 上传附件
		attachUpload(data) {
			// Countly.add_event({
			// 	// key: "mail_upload",
			// 	key: "上传附件",
			// 	count: 1,
			// 	segmentation: data || null
			// })
		},
		// 彻底删除邮件
		mailShiftDelete(data) {
			// Countly.add_event({
			// 	// key: "mail_delete_completely",
			// 	key: "彻底删除邮件",
			// 	count: 1,
			// 	segmentation: data || null
			// })
		},
		// 删除邮件
		mailDelete(data) {
			// Countly.add_event({
			// 	// key: "mail_delete",
			// 	key: "删除邮件",
			// 	count: 1,
			// 	segmentation: data || null
			// })
		},
		// 新建会议邮件
		addMeeting(data) {
			// Countly.add_event({
			// 	// key: "mail_add_meetings",
			// 	key: "新建会议邮件",
			// 	count: 1,
			// 	segmentation: data || null
			// })
		},
		// 选择会议室
		chooseMeetingRoom(data) {
			// Countly.add_event({
			// 	// key: "mail_choose_room",
			// 	key: "选择会议室",
			// 	count: 1,
			// 	segmentation: data || null
			// })
		},
		// 设置邮件类型
		mailType(data) {
			// Countly.add_event({
			// 	// key: "mail_tpye",
			// 	key: "设置邮件类型",
			// 	count: 1,
			// 	segmentation: data || null
			// })
		},
		// 选择已读回执
		mailReadRequest(data) {
			// Countly.add_event({
			// 	// key: "mail_read_request",
			// 	key: "选择请求已读回执",
			// 	count: 1,
			// 	segmentation: data || null
			// })
		},
		// 设置为已读
		mailSetRead(data) {
			// Countly.add_event({
			// 	// key: "mail_set_read",
			// 	key: "设置为已读",
			// 	count: 1,
			// 	segmentation: data || null
			// })
		},
		// 设置为未读
		mailSetUnread(data) {
			// Countly.add_event({
			//   // key: "mail_set_unread",
			//   key: "设置为未读",
			//   count: 1,
			//   segmentation: data || null
			// })
		},
		// 设置为上下布局
		setUpdown(data) {
			// Countly.add_event({
			//   // key: "mail_set_updown",
			//   key: "设置为上下布局",
			//   count: 1,
			//   segmentation: data || null
			// })
		},
		// 设置为左右布局
		setLeftright(data) {
			// Countly.add_event({
			//   // key: "mail_set_leftright",
			//   key: "设置为左右布局",
			//   count: 1,
			//   segmentation: data || null
			// })
		},
		// 关闭预览窗口
		closePreview(data) {
			// Countly.add_event({
			//   // key: "mail_close_preview",
			//   key: "关闭预览窗口",
			//   count: 1,
			//   segmentation: data || null
			// })
		},
		// 跳转到bpm流程管理系统
		toBpm() {
			// Countly.add_event({
			//   // key: "mail_to_bpm",
			//   key: "跳转到BPM",
			//   count: 1,
			//   segmentation: null
			// })
		},
		// 点赞
		clickLaud(data) {
			// Countly.add_event({
			//   // key: "mail_click_laud",
			//   key: "点赞",
			//   count: 1,
			//   segmentation: data || null
			// })
		},
		// 吐槽
		makeComplaints(type) {
			// todo 1:难操作 2:速度慢 3:其他
			// var ss = ["难操作", "速度慢", "其他"]
			// Countly.add_event({
			//   // key: "mail_make_complaints",
			//   key: "吐槽-" + ss[type - 1],
			//   count: 1,
			//   segmentation: null
			// })
		},
		// 联系客服
		contaCustomerService(data) {
			// Countly.add_event({
			//   // key: "mail_contact_customer",
			//   key: "联系客服",
			//   count: 1,
			//   segmentation: data || null
			// })
		},
		// 吉信跳转到写信页面
		imToWriteEmail(data) {
			// Countly.add_event({
			//   // key: "im_to_writeEmail",
			//   key: "吉信跳转到写信页面",
			//   count: 1,
			//   segmentation: data || null
			// })
		}
	}
}



// WEBPACK FOOTER //
// ./src/utils/index.js